import { gql } from 'graphql-request';

export const FETCH_SIMILAR_CONTENTS_QUERY = gql`
  query (
    $id: ID!
    $filter: ContentFilter!
    $collectionFilter: CollectionFilter!
  ) {
    similarContent(id: $id, filter: $filter) {
      __typename
      id
      title
      originalTitle
      description
      image {
        list
        cover
        listClean
        sticker
        svodCover
        appCover
        channelSquare
        channelList
        square
        portrait
        logo
        verticalBanner
        mobileBanner
        desktopBanner
      }
      billingType
      businessType
      duration
      contentOwner
      genres {
        id
        value
      }
      languages
      assetType
      assetSubType
      releaseDate
      actors
      ageRating
      audioLanguages
      subtitleLanguages
      eventLive
      tags
      tier
      seoTitle
      slug
      webUrl
      rating
      video {
        url
        drmKey
        hlsUrl
        isDrm
      }
      relatedVideos {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
        }
        nextUrl
        page
        size
        totalResults
      }
      relatedCollections {
        title
        originalTitle
        collections(filter: $collectionFilter) {
          id
          title
          originalTitle
          description
          image {
            list
            cover
            listClean
            sticker
            svodCover
            appCover
            channelSquare
            channelList
            square
            portrait
            logo
            verticalBanner
            mobileBanner
            desktopBanner
          }
          tags
          page
          size
          totalResults
          assetSubType
          extended {
            personalizationType
            personalizationMetaData
          }
        }
      }
      relatedTvShows {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          __typename
        }
        nextUrl
        page
        size
        totalResults
      }
      relatedMovies {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
        }
        nextUrl
        page
        size
        totalResults
      }
      relatedChannels {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          __typename
        }
        nextUrl
        page
        size
        totalResults
      }
    }
  }
`;

export const FETCH_SIMILAR_CONTENTS_QUERY_FOR_BOT_REQUEST = gql`
  query ($id: ID!, $filter: ContentFilter!) {
    similarContent(id: $id, filter: $filter) {
      __typename
      id
      title
      originalTitle
      description
      image {
        list
        cover
        listClean
        sticker
        svodCover
        appCover
        channelSquare
        channelList
        square
        portrait
        logo
        verticalBanner
        mobileBanner
        desktopBanner
      }
      billingType
      businessType
      duration
      contentOwner
      genres {
        id
        value
      }
      languages
      assetType
      assetSubType
      releaseDate
      actors
      ageRating
      audioLanguages
      subtitleLanguages
      eventLive
      tags
      tier
      seoTitle
      slug
      webUrl
      rating
      video {
        url
        drmKey
        hlsUrl
        isDrm
      }
      relatedVideos {
        id
        title
        originalTitle
        image {
          list
          cover
          listClean
          sticker
          svodCover
          appCover
          channelSquare
          channelList
          square
          portrait
          logo
          verticalBanner
          mobileBanner
          desktopBanner
        }
        genres {
          id
          value
        }
        tags
        slug
        position
        contents {
          ... on Movie {
            id
            title
            originalTitle
            duration
            contentOwner
            businessType
            genres {
              id
              value
            }
            languages
            description
            assetType
            assetSubType
            releaseDate
            image {
              list
              cover
              sticker
              svodCover
            }
            actors
            ageRating
            audioLanguages
            subtitleLanguages
            eventLive
            tags
            introStartTime
            introEndTime
            billingType
            tier
            playDate
            seoTitle
            slug
            webUrl
            rating
            playedDuration
            video {
              isDrm
              url
              hlsUrl
              drmKey
            }
            relatedContentIds {
              id
            }
          }
        }
        nextUrl
        page
        size
        totalResults
      }
    }
  }
`;
